import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Icon from "../AppIcon";
import Image from "../AppImage";

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [language, setLanguage] = useState("ar");

  useEffect(() => {
    const savedLanguage = localStorage.getItem("language") || "en";
    setLanguage(savedLanguage);
    document.documentElement.dir = savedLanguage === "ar" ? "rtl" : "ltr";
  }, []);

  const navigationItems = [
    {
      path: "/users-management-hub",
      label: { en: "Users", ar: "المستخدمون" },
      icon: "Users",
    },
    {
      path: "/workshops",
      label: { en: "Workshops", ar: "الورش" },
      icon: "Wrench",
    },
    {
      path: "/emergency-service-providers-crud",
      label: { en: "Emergency", ar: "الطوارئ" },
      icon: "AlertCircle",
    },
    {
      path: "/products-crud-management",
      label: { en: "Products", ar: "المنتجات" },
      icon: "Package",
    },
       {
      path: "/discount-products-crud-management",
      label: { en: "offers", ar: "العروض" },
      icon: "Package",
    },
    {
      path: "/banner-ads-crud-management",
      label: { en: "Banner Ads", ar: "إعلانات البانر" },
      icon: "Image",
    },
      {
      path: "/notifications-management",
      label: { en: "Notifications", ar: "الإشعارات" },
      icon: "BellRing",
    },
    {
      path: "/user-cars-profile-management",
      label: { en: "User Cars", ar: "سيارات المستخدمين" },
      icon: "Car",
    },
    {
      path: "/tags-management",
      label: { en: "Tags", ar: "الوسومات " },
      icon: "Tag",
    },
    {
      path: "/enhanced-orders-management-interface",
      label: { en: "Orders", ar: "الطلبات" },
      icon: "ShoppingCart",
    },
    {
      path: "/governorates-areas-hierarchical-management",
      label: { en: "Locations", ar: "المواقع" },
      icon: "MapPin",
    },
  ];

  const moreItems = [
    {
      path: "/car-types",
      label: { en: "Car Types", ar: "أنواع السيارات" },
      icon: "Car",
    },
    {
      path: "/analytics",
      label: { en: "Analytics", ar: "التحليلات" },
      icon: "BarChart3",
    },
    {
      path: "/system",
      label: { en: "System", ar: "النظام" },
      icon: "Settings",
    },
    {
      path: "/reports",
      label: { en: "Reports", ar: "التقارير" },
      icon: "FileText",
    },
    {
      path: "/monitor",
      label: { en: "Monitor", ar: "المراقبة" },
      icon: "Activity",
    },
  ];

  const isActive = (path) => location.pathname === path;

  const handleNavigation = (path) => {
    navigate(path);
    setIsMobileMenuOpen(false);
  };

  const toggleLanguage = () => {
    const newLanguage = language === "en" ? "ar" : "en";
    setLanguage(newLanguage);
    localStorage.setItem("language", newLanguage);
    document.documentElement.dir = newLanguage === "ar" ? "rtl" : "ltr";
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.clear();
    navigate("/admin-login-authentication");
  };

  return (
    <>
      <header className="header-nav">
        <div className="header-container">
          {/* Logo */}
          <div className="header-logo">
            <Image
              src="/assets/images/Untitled_design-1768127845076.png"
              alt="AdminPanel Logo"
              className="w-10 h-10 object-contain"
            />
            <span className="header-logo-text">
              {language === "en" ? "AdminPanel" : "لوحة الإدارة"}
            </span>
          </div>

          {/* Desktop Navigation */}
          <nav className="header-nav-list">
            {navigationItems.map((item) => (
              <button
                key={item.path}
                onClick={() => handleNavigation(item.path)}
                className={`header-nav-item ${isActive(item.path) ? "active" : ""}`}
              >
                <Icon name={item.icon} size={16} className="mr-2" />
                {item.label[language]}
              </button>
            ))}
          </nav>

          {/* Actions */}
          <div className="header-actions">
            <button
              onClick={toggleLanguage}
              className="language-button"
              aria-label="Switch language"
            >
              <Icon name="Languages" size={20} />
              <span className="text-sm font-medium">
                {language.toUpperCase()}
              </span>
            </button>

            <button
              onClick={handleLogout}
              className="flex items-center gap-2 px-3 py-2 rounded-lg text-error hover:bg-error/10 transition"
            >
              <Icon name="LogOut" size={18} />
              <span className="text-sm">
                {language === "ar" ? "تسجيل خروج" : "Logout"}
              </span>
            </button>
          </div>

          {/* Mobile Toggle */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="header-mobile-toggle"
          >
            <Icon name={isMobileMenuOpen ? "X" : "Menu"} size={24} />
          </button>
        </div>
      </header>

      {/* Mobile Menu */}
      <div
        className={`header-mobile-menu ${!isMobileMenuOpen ? "closed" : ""}`}
      >
        <div className="header-mobile-menu-content">
          <nav className="flex flex-col gap-2">
            {[...navigationItems, ...moreItems].map((item) => (
              <button
                key={item.path}
                onClick={() => handleNavigation(item.path)}
                className={`header-mobile-nav-item ${isActive(item.path) ? "active" : ""}`}
              >
                <Icon name={item.icon} size={20} className="mr-3" />
                {item.label[language]}
              </button>
            ))}
          </nav>

          {/* Mobile Logout */}
          <div className="mt-4 border-t pt-4">
            <button
              onClick={handleLogout}
              className="w-full flex items-center gap-3 px-4 py-3 rounded-lg text-error hover:bg-error/10 transition"
            >
              <Icon name="LogOut" size={20} />
              {language === "ar" ? "تسجيل خروج" : "Logout"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
